import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { TableWork } from '../../ui'
import { useGetAllNullificationQuery } from '../../services/nullificationservice'
import { NO_RECORDS_FOUND, APPROVE, REJECT } from '../../constants/constants'
import Modal from '../../library/components/Modal/modal'
import './index.css'
import Afterapprove from './AfterApprove'
import Rejectnullification from './RejectNullification'
import Table from "../../ui/datatable/DataTable";
import { downloadExcelFile, downloadFile, downloadPdfFile } from "../utilities/utils"
import pdfIcon from "../../images/pdfIcon.png"
import excelIcon from "../../images/excelIcon.png"
import moment from 'moment'
const tableHeader = [
  'Sr No.',
  'State Name',
  'Election Type',
  'Constituency Type',
  'Constituency No. & Name',
  'Reason for Nullification',
  'Date of Nullification',
  'Action',
]

const Pendingrequest = (props) => {
  const [totalNoOfRecords, setTotalNoOfRecords] = useState()
  const { data } = useGetAllNullificationQuery()
  const tableData = []
  const reportName = "Nullification List"
  const SheetName = "Nullification List"
  const [approveIsVisible, setApproveIsVisible] = useState(false)
  const [rejectIsVisible, setRejectIsVisible] = useState(false)
  const [constNameNoAndStateName, setConstNameNoAndStateName] = useState({
    constName: '',
    stateName: '',
    constNo: ''
  })
  const tableHeader = [];
  const columns = [
    {
      Header: "Sr No.",
      accessor: "S_No",
    },
    {
      Header: "State Name",
      accessor: "Statename",
    },
    {
      Header: "Election Type",
      accessor: "Election Type",
    },
    {
      Header: "Constituency Type",
      accessor: "Constituency Type",
    },
    {
      Header: "Constituency No. & Name",
      accessor: "Constituency No & Name",
    },
    {
      Header: "Reason for Nullification",
      accessor: "Reason",
    },
    {
      Header: "Date of Nullification",
      accessor: "Date Of Notification",
    },
    {
      Header: "Document",
      accessor: "Document",
    },
    {
      Header: "Action",
      accessor: "Status",
    },

  ];
  columns.map((item) => {
    tableHeader.push(item.Header)
  })

  let pdfTableData = [];

  const updateSelectedConstNameNoAndStateName = (constName, stateName, constNo) => {
    setConstNameNoAndStateName({
      constName: constName,
      stateName: stateName,
      constNo: constNo
    })
  }
  // `${item.constNo} - ${item.constName}`
  const openModal = (constName, stateName, constNo) => {
    setApproveIsVisible(true)
    updateSelectedConstNameNoAndStateName(constName, stateName, constNo)
  }
  const openRejectModal = (constName, stateName, constNo) => {
    setRejectIsVisible(true)
    updateSelectedConstNameNoAndStateName(constName, stateName, constNo)
  }
  let FilteredData = data?.payload?.nullificationDataList?.filter(
    (e) => e.status === (props.value || e.status),
  )


  FilteredData?.map((item, i) => {
    tableData.push({
      'S_No': i + 1,
      Statename: item.stateName,
      'Election Type': item.electionType,
      'Constituency Type': item.constType,
      'Constituency No & Name': `${item.constNo} - ${item.constName}`,
      Reason:
        (item.approveRejectComment === 'Approved' || item.approveRejectComment ==="")
          ?item.reasonForNullification 
          :item.approveRejectComment,
      'Date Of Notification': moment(new Date(item.submittedOn)).format("DD-MM-YYYY hh:mm A"),
      "Document":item.document !==null ? <i className="fa fa-download" style={{ cursor:"pointer", paddingLeft:"10px"}} onClick={()=>{downloadFile(item?.document)}} />:"NA",
      Status:
        props.label === 'show' ? (
          <span>
            <Link
              className="simple-link"
              to=""
              state={item.id}
              onClick={() =>
                openModal(item.constName, item.stateName , item.constNo)
              }
            >
              <i className="fa-solid fa-circle-check approve-btn" />
              {APPROVE}
            </Link>
            <br></br>
            <Link
              className="simple-link"
              to=""
              state={item.id}
              onClick={() =>
                openRejectModal(
                   item.constName,
                  item.stateName,
                  item.constNo
                )
              }
            >
              <i className="fa-solid fa-ban reject-btn" /> {REJECT}
            </Link>
          </span>
        ) : (
          <span className={item.status}>{item.status}</span>
        ),
    })
    pdfTableData.push({
      'S_No': i + 1,
      Statename: item.stateName,
      'Election Type': item.electionType,
      'Constituency Type': item.constType,
      'Constituency No & Name': `${item.constNo} - ${item.constName}`,
      Reason:
        (item.approveRejectComment === 'Approved' || item.approveRejectComment ==="")
          ?item.reasonForNullification 
          :item.approveRejectComment,
      'Date Of Notification': item.submittedOn,
      Document:item.document !==null ? "Available":"NA",
      Status: item.status
    })
  })

  useEffect(()=>{
    setTotalNoOfRecords(FilteredData?.length)
  },[FilteredData])

  return (
    <>
      <div className="offset-8 col-md-4 row" style={{position: "relative", bottom: "54px" }}>
        <div className='ml-5'>
          <img src={pdfIcon} width="35px" height="28px" className=" reports_icon_button" onClick={() => downloadPdfFile(reportName, tableHeader, pdfTableData)} />
        </div>
        <div className="ml-1">
          <img src={excelIcon} width="40px" height="30px" className=" reports_icon_button" onClick={() => downloadExcelFile(reportName, SheetName, tableHeader, pdfTableData)} />
        </div>
      </div>

      {tableData.length > 0 ? (
        // <TableWork
        //   id=""
        //   theadData={tableHeader}
        //   tbodyData={tableData}
        //   anchorTagName=""
        //   anchorTagclassName="viewDetails"
        //   emptyMessage="No data found"
        //   pageSize={10}
        //   pagination={true}
        //   paginationClass={'text-right p-0'}
        // />
        <div style={{position:"relative",bottom:"45px"}}>  
          <Table
          placeholder="Search"
          globalsearch={true}
          emptyMessage="No Record Found"
          selectall={true}
          columns={localStorage.userrole ==="epba"?columns:columns.splice(0,8)}
          data={tableData?.length === 0 ? [] : tableData}
          size={5}
          tableClassNameCheck="contenttable-eroll"
          pagination
          records
          gotopage
          rows
          numberrows={totalNoOfRecords}
        /></div>

      ) : (
        <label className="no-records-found">{NO_RECORDS_FOUND}</label>
      )}

      <div>
        <Modal
          show={approveIsVisible}
          onClose={() => setApproveIsVisible(false)}
          modalTitle="Approval"
          className="modal-width"
          size={900}
        >
          <Afterapprove
            constNameNoAndState={constNameNoAndStateName}
            onSendOtpError={() => setApproveIsVisible(false)}
            onRequestApprove={() => setApproveIsVisible(false)}
          ></Afterapprove>
        </Modal>
        <Modal
          show={rejectIsVisible}
          onClose={() => setRejectIsVisible(false)}
          modalTitle="Reject"
          className="modal-width"
          size={900}
        >
          <Rejectnullification
            constNameNoAndState={constNameNoAndStateName}
            onRejectRequest={() => setRejectIsVisible(false)}
          ></Rejectnullification>
        </Modal>
      </div>
    </>
  )
}

export default Pendingrequest
